import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';

import { Observable } from 'rxjs';

import { BodyListResponse } from 'src/app/core/models/general/body-list-response';
import { BodyResponse } from 'src/app/core/models/general/body-response';

import { InstitucionFinancieraDTO } from 'src/app/core/models/persona/interfaces';

import { environment } from 'src/environments/environment';

const API_URL = environment.apiUrlPersona;

@Injectable()
export class InstitucionFinancieraService {
  header = new Headers({ 'Content-Type': 'application/json' });

  constructor(private http: HttpClient) {}

  getInstitucionFinancieraService(): Observable<BodyListResponse<InstitucionFinancieraDTO>> {
    return this.http.get<BodyListResponse<InstitucionFinancieraDTO>>(API_URL + '/api/v1/institucionFinanciera/todos');
  }

  guardarInstitucionFinancieraService(institucionFinancieraDTO: InstitucionFinancieraDTO): Observable<InstitucionFinancieraDTO> {
    return this.http.post<InstitucionFinancieraDTO>(API_URL + '/api/v1/institucionFinanciera', institucionFinancieraDTO);
  }

  getInstitucionFinancieraPorCodigoInstitucionFinancieraService(codigoInstitucionFinanciera: string): Observable<BodyResponse<InstitucionFinancieraDTO>> {
    return this.http.get<BodyResponse<InstitucionFinancieraDTO>>(API_URL + '/api/v1/institucionFinanciera/' + codigoInstitucionFinanciera);
  }
}
